import { API, authClient } from "../index";

export const postEvent = async (event) => {
	return authClient().post(`${API}/event`, event);
};

export const getEvents = (query) => {
	return authClient().get(`${API}/event${query || ""}`);
};

export const getEventById = (id) => {
	return authClient().get(`${API}/event/${id}`);
};

export const updateEvent = async (id, event) => {
	return authClient().put(`${API}/event/${id}`, event);
};

export const changeStatusEvent = async (id, active) => {
	return authClient().put(`${API}/event/change-status/${id}`, {
		active,
	});
};

export const deleteEvent = (id) => {
	return authClient().delete(`${API}/event/${id}`);
};
